/* ez-kb-article.js — click-to-zoom lightbox for KB guide diagrams (template.suffix == 'kb').
   Any figure/media image (except video embeds) opens fullscreen; click or ESC closes. */
(function () {
  'use strict';
  var rte = document.querySelector('.ez-doc__rte');
  if (!rte) return;
  var box = null;

  function ensure() {
    if (box) return box;
    box = document.createElement('div');
    box.className = 'ez-kblb';
    box.hidden = true;
    box.appendChild(document.createElement('img'));
    box.addEventListener('click', close);
    document.body.appendChild(box);
    return box;
  }
  function open(src) { var b = ensure(); b.querySelector('img').src = src; b.hidden = false; }
  function close() { if (box) box.hidden = true; }

  rte.addEventListener('click', function (e) {
    var img = e.target.closest && e.target.closest('figure img, li.kb-media img');
    if (!img || img.closest('figure.embed')) return;
    e.preventDefault();
    open(img.currentSrc || img.src);
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
})();
